import { StyleSheet, Platform } from 'react-native';
import { getResponsiveValue } from './breakpoints';
import { colors, typography, shadows, spacing, borderRadius } from './theme';

export const venueStyles = StyleSheet.create({
  venueContainer: {
    flex: 1,
    borderRadius: 20,
    padding: getResponsiveValue({
      mobile: 20,
      tablet: 25,
      laptop: 43,
      desktop: 43
    }),
    width: '100%',
    maxWidth: 1400,
    alignSelf: 'center',
    marginTop: getResponsiveValue({
      mobile: 0,
      tablet: 0,
      laptop: 0,
      desktop: 0
    }),
  },
  backButton: {
    backgroundColor: '#000000',
    borderRadius: 8,
    padding: getResponsiveValue({
      mobile: 15,
      tablet: 10,
      laptop: 10,
      desktop: 10,
    }),
    alignItems: 'center',
    marginBottom: 20,
    alignSelf: 'flex-start',
    minWidth: getResponsiveValue({
      mobile: 100,
      tablet: 'auto',
      laptop: 'auto',
      desktop: 'auto',
    }),
  },
  backButtonText: {
    color: '#ffffff',
    fontFamily: 'VastagoGrotesk',
    fontSize: getResponsiveValue({
      mobile: '1.125rem',
      tablet: '1rem',
      laptop: '1rem',
      desktop: '1rem',
    }),
  },
  venueAddress: {
    fontFamily: 'VastagoGrotesk',
    fontWeight: '400',
    fontSize: Platform.OS === 'web' ? '1.125rem' : '1rem',
    color: '#000000',
    textAlign: 'center',
    marginTop: 5,
    marginBottom: 5,
    textShadow: Platform.OS === 'web' ? '0px 4px 4px rgba(0,0,0,0.25)' : undefined,
  },
  venueWebsite: {
    fontFamily: 'VastagoGrotesk',
    fontWeight: '400',
    fontSize: Platform.OS === 'web' ? '1rem' : '0.875rem',
    color: '#7cff75',
    textAlign: 'center',
    marginBottom: 10,
    textDecorationLine: 'underline',
    ...(Platform.OS === 'web' && {
      cursor: 'pointer',
    }),
  },
  venueDetails: {
    backgroundColor: colors.backgroundSquares,
    borderRadius: 10,
    padding: 15,
    marginBottom: 15,
  },
  technicalDetails: {
    backgroundColor: colors.backgroundSquares,
    borderRadius: 10,
    padding: 15,
    marginBottom: 15,
  },
  facilityDetails: {
    backgroundColor: colors.backgroundSquares,
    borderRadius: 10,
    padding: 15,
    marginBottom: 15,
  },
  notesSection: {
    backgroundColor: colors.backgroundSquares,
    borderRadius: 10,
    padding: 15,
    marginBottom: 15,
  },
  sectionTitle: {
    fontFamily: 'VastagoGrotesk',
    fontWeight: '700',
    fontSize: '1.25rem',
    color: '#000000',
    marginBottom: 10,
    textAlign: 'center',
  },
  detailText: {
    fontFamily: 'VastagoGrotesk',
    fontWeight: '400',
    fontSize: '0.875rem',
    color: '#000000',
    marginBottom: 5,
  },
  detailHeader: {
    fontFamily: 'VastagoGrotesk',
    fontWeight: '500',
    fontSize: '1rem',
    color: '#000000',
    marginTop: 10,
    marginBottom: 5,
  },
  detailsGrid: {
    flexDirection: Platform.OS === 'web' ? 'row' : 'column',
    gap: 20,
    marginTop: 10,
  },
  detailsColumn: {
    flex: 1,
    minWidth: Platform.OS === 'web' ? 200 : '100%',
  },
  mapSection: {
    width: '100%',
    marginTop: 20,
    backgroundColor: colors.backgroundSquares,
    borderRadius: 10,
    padding: 15,
  },
  linkButton: {
    backgroundColor: 'rgba(46, 204, 113, 0.2)',
    padding: getResponsiveValue({
      mobile: 15,
      tablet: 10,
      laptop: 10,
      desktop: 10,
    }),
    borderRadius: 8,
    marginTop: 10,
    alignItems: 'center',
    minHeight: getResponsiveValue({
      mobile: 50,
      tablet: 'auto',
      laptop: 'auto',
      desktop: 'auto',
    }),
  },
  linkButtonText: {
    fontFamily: 'VastagoGrotesk',
    fontWeight: '500',
    fontSize: getResponsiveValue({
      mobile: '1rem',
      tablet: '0.875rem',
      laptop: '0.875rem',
      desktop: '0.875rem',
    }),
    color: '#2ecc71',
  },
  actionButton: {
    backgroundColor: '#F7EEEE',
    paddingVertical: getResponsiveValue({
      mobile: 15,
      tablet: 10,
      laptop: 10,
      desktop: 10,
    }),
    paddingHorizontal: getResponsiveValue({
      mobile: 25,
      tablet: 15,
      laptop: 15,
      desktop: 15,
    }),
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: getResponsiveValue({
      mobile: 10,
      tablet: 0,
      laptop: 0,
      desktop: 0,
    }),
    minWidth: getResponsiveValue({
      mobile: '100%',
      tablet: '31%',
      laptop: '31%',
      desktop: '31%',
    }),
    minHeight: getResponsiveValue({
      mobile: 50,
      tablet: 50,
      laptop: 50,
      desktop: 50,
    }),
    flex: getResponsiveValue({
      mobile: 0,
      tablet: 0,
      laptop: 0,
      desktop: 0,
    }),
    textAlign: 'center',
    ...(Platform.OS === 'web' && {
      cursor: 'pointer',
      transition: 'all 0.2s ease',
    }),
  },
  specialButton: {
    flex: getResponsiveValue({
      mobile: 0,
      tablet: 0,
      laptop: 0,
      desktop: 0,
    }),
    paddingHorizontal: getResponsiveValue({
      mobile: 25,
      tablet: 15,
      laptop: 15,
      desktop: 15,
    }),
    paddingVertical: getResponsiveValue({
      mobile: 15,
      tablet: 10,
      laptop: 10,
      desktop: 10,
    }),
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.purpleReplacement,
    minHeight: getResponsiveValue({
      mobile: 50,
      tablet: 'auto',
      laptop: 'auto',
      desktop: 'auto',
    }),
    minWidth: getResponsiveValue({
      mobile: '100%',
      tablet: '100%',
      laptop: '100%',
      desktop: '100%',
    }),
    textAlign: 'center',
    marginBottom: getResponsiveValue({
      mobile: 10,
      tablet: 0,
      laptop: 0,
      desktop: 0,
    }),
    ...(Platform.OS === 'web' && {
      cursor: 'pointer',
      transition: 'transform 0.2s ease, background-color 0.2s ease',
      ':hover': {
        transform: 'scale(1.03)',
      },
    }),
  },
  actionButtonActive: {
    backgroundColor: colors.purpleReplacement,
    ...(Platform.OS === 'web' && {
      ':hover': {
        transform: 'scale(1.03)',
      },
    }),
  },
  actionButtonText: {
    color: '#000000',
    fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    fontSize: getResponsiveValue({
      mobile: '1.1rem',
      tablet: '1rem',
      laptop: '.9rem',
      desktop: '.9rem',
    }),
    fontWeight: '700',
    textAlign: 'center',
    padding: 5,
    letterSpacing: 5,
    ...(Platform.OS === 'web' && {
      transition: 'color 0.2s ease',
    }),
  },
  disabledButton: {
    backgroundColor: 'rgba(155, 77, 255, 0.3)',
    opacity: 0.7,
    ...(Platform.OS === 'web' && {
      cursor: 'not-allowed',
    }),
  },
  tooltipContainer: {
    position: 'absolute',
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    padding: 10,
    borderRadius: 5,
    zIndex: 1000,
    maxWidth: 200,
    top: -40,
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'none',
  },
  tooltipText: {
    color: 'white',
    fontSize: '0.75rem',
    textAlign: 'center',
  },
  tooltipVisible: {
    display: 'block',
  },
  searchSection: {
    width: '100%',
    padding: 10,
    marginBottom: 20,
  },
  mainContent: {
    borderRadius: 20,
    width: '100%',
    padding: 20,
  },
  headerStyle: {
    display: 'flex',
    flexDirection: getResponsiveValue({
      mobile: 'column',
      tablet: 'row',
      laptop: 'row',
      desktop: 'row'
    }),
    gap: getResponsiveValue({
      mobile: 10,
      tablet: 20,
      laptop: 20,
      desktop: 20,
    }),
    width: '100%',
    marginBottom: getResponsiveValue({
      mobile: 0,
      tablet: 20,
      laptop: 20,
      desktop: 20,
    }),
    alignItems: getResponsiveValue({
      mobile: 'center',
      tablet: 'flex-start',
      laptop: 'flex-start',
      desktop: 'flex-start'
    }),
    justifyContent: getResponsiveValue({
      mobile: 'center',
      tablet: 'space-between',
      laptop: 'space-between',
      desktop: 'space-between'
    }),
  },
  // Two rows of three columns - same flex so columns align across rows
  venueTwoRowGrid: {
    width: '100%',
    flexDirection: 'column',
    marginBottom: 20,
  },
  venueGridRow: {
    flexDirection: 'row',
    width: '100%',
    gap: getResponsiveValue({
      mobile: 10,
      tablet: 5,
      laptop: 15,
      desktop: 20,
    }),
    minWidth: 0,
    alignItems: 'stretch',
  },
  venueGridCol1: {
    // Same width as venueGridCol3 so the report-card chalkboard matches the map card.
    flex: 0.75,
    minWidth: 0,
  },
  venueGridCol2: {
    flex: 1.5,
    minWidth: 0,
  },
  venueGridCol3: {
    flex: 0.75,
    minWidth: 0,
  },
  headerSection: {
    flexDirection: getResponsiveValue({
      mobile: 'row',
      tablet: 'row',
      laptop: 'row',
      desktop: 'row',
    }),
    gap: 20,
    // marginBottom: 15,
    marginTop: 20,
    flexWrap: getResponsiveValue({
      mobile: 'wrap',
      tablet: 'wrap',
      laptop: 'nowrap',
      desktop: 'nowrap',
    }),
    justifyContent: 'space-between',
  },
  venueInfo: {
    flex: 1,
    minWidth: 240,
    backgroundColor: colors.backgroundSquares,
    borderRadius: 10,
    padding: 10,
  },
  venueName: {
    fontFamily: 'VastagoGrotesk',
    fontWeight: '500',
    fontSize: Platform.OS === 'web' ? '3rem' : '2.5rem',
    color: '#FFE99C',
    textAlign: 'center',
    width: '80%',
    ...(Platform.OS === 'web' && {
      textShadow: '0px 2px 4px rgba(0, 0, 0, 0.5)',
    }),
  },
  venueNameContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 15,
    position: 'relative',
  },
  mobileTitleCard: {
    marginBottom: 'auto',
  },
  inlineGrade: {
    fontFamily: 'DazHandwriting',
    fontWeight: '700',
    fontSize: Platform.OS === 'web' ? '4rem' : '2.5rem',
    color: 'white',
    textShadow: Platform.OS === 'web' ? '0px 4px 4px rgba(0,0,0,0.25)' : undefined,
    display: getResponsiveValue({
      mobile: 'none',
      tablet: 'none',
      laptop: 'flex',
      desktop: 'flex',
    }),
  },
  inlineSaveButton: {
    position: 'absolute',
    top: -25,
    right: -25,
    padding: 8,
    display: getResponsiveValue({
      mobile: 'none',
      tablet: 'none',
      laptop: 'flex',
      desktop: 'flex',
    }),
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    transform: 'rotate(10deg)',
    transition: 'transform 0.3s ease-in-out, filter 0.3s ease-in-out',
    cursor: 'pointer',
    zIndex: 10,
  },
  inlineSaveButtonIcon: {
    width: 100,
    height: 100,
    objectFit: 'contain',
    ...getResponsiveValue({
      mobile: {
        width: 50,
        height: 50,
      },
      tablet: {
        width: 80,
        height: 80,
      },
      laptop: {
        width: 80,
        height: 80,
      },
      desktop: {
        width: 80,
        height: 80,
      },
    })
  },
  buttonGroup: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: getResponsiveValue({
      mobile: 15,
      tablet: 10,
      laptop: 10,
      desktop: 10,
    }),
    padding: getResponsiveValue({
      mobile: 8,
      tablet: 4,
      laptop: 4,
      desktop: 4,
    }),
    marginTop: getResponsiveValue({
      mobile: 15,
      tablet: 0,
      laptop: 0,
      desktop: 0,
    }),
    width: getResponsiveValue({
      mobile: '95%',
      tablet: '100%',
      laptop: '100%',
      desktop: '100%',
    }),
    alignSelf: 'center',
  },
  overallGradeCard: {
    flex: getResponsiveValue({
      mobile: 1,
      tablet: 1,
      laptop: 0.7,
      desktop: 0.7,
    }),
    // backgroundColor: colors.backgroundSquares,
    borderRadius: 10,
    padding: 10,
    alignItems: 'center',
    justifyContent: 'center',
    order: getResponsiveValue({
      mobile: 2,
      tablet: 2,
      laptop: 1,
      desktop: 1,
    }),
    minHeight: getResponsiveValue({
      mobile: 'auto',
      tablet: 'auto',
      laptop: '100%',
      desktop: '100%',
    }),
    maxHeight: getResponsiveValue({
      mobile: 'none',
      tablet: 'auto',
      laptop: 'none',
      desktop: 'none',
    }),
    width: getResponsiveValue({
      mobile: '90vw',
      tablet: 'auto',
      laptop: 'auto',
      desktop: 'auto',
    }),
    alignSelf: getResponsiveValue({
      mobile: 'center',
      tablet: 'auto',
      laptop: 'auto',
      desktop: 'auto',
    }),
    marginBottom: getResponsiveValue({
      mobile: 0,
      tablet: 0,
      laptop: 0,
      desktop: 0,
    }),
    gap: getResponsiveValue({
      mobile: 0,
      tablet: 0,
      laptop: 5,
      desktop: 5,
    }),
    position: 'relative',
  },
  gradeTitle: {
    fontFamily: 'Glacial Indifference',
    fontWeight: '700',
    fontSize: '1.5rem',
    color: 'white',
    textShadow: Platform.OS === 'web' ? '0px 4px 4px rgba(0,0,0,0.25)' : undefined,
  },
  reportCount: {
    fontFamily: 'VastagoGrotesk',
    fontWeight: '500',
    fontStyle: 'normal',
    marginBottom: 10,
    fontSize: '0.875rem',
    color: colors.letterGrade,
    textShadow: Platform.OS === 'web' ? '0px 4px 4px rgba(0,0,0,0.25)' : undefined,
  },
  gradeLetter: {
    fontFamily: 'EduSAHand',
    fontWeight: '300',
    fontSize: Platform.OS === 'web' ? '4.5rem' : '2.0rem',
    fontSize: getResponsiveValue({
      mobile: '1.8rem',
      tablet: '1.8rem',
      laptop: '3.5rem',
      desktop: '4.5rem',
    }),
    lineHeight: "110%",
    color: colors.letterGrade,
    marginTop: 10,
    textShadow: Platform.OS === 'web' ? '0px 4px 4px rgba(0,0,0,0.25)' : undefined,
  },
  subcategoryGradesContainer: {
    marginTop: 20,
    marginBottom: 15,
    width: '100%',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
    paddingHorizontal: 5,
  },
  subcategoryGradeItem: {
    alignItems: 'center',
    width: '30%',
  },
  subcategoryGradeLabel: {
    color: 'white',
    fontSize: 14,
    fontWeight: 'bold',
    marginBottom: 4,
    textShadow: Platform.OS === 'web' ? '0px 4px 4px rgba(0,0,0,0.25)' : undefined,
  },
  subcategoryGradeValue: {
    fontFamily: 'Playpen Sans',
    color: 'white',
    fontSize: 20,
    fontWeight: 'bold',
    textShadow: Platform.OS === 'web' ? '0px 4px 4px rgba(0,0,0,0.25)' : undefined,
  },
  contentSection: {
    flexDirection: 'row',
    gap: 20,
    // backgroundColor: colors.backgroundSquares,
    width: '100%',
    borderRadius: 10,
    padding: 20,
    marginTop: 20,
    minHeight: 600,
  },
  leftSection: {
    flex: 1,
    minWidth: 0,
  },
  rightSection: {
    width: '40%',
    minWidth: 300,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  discussionSection: {
    padding: 20,
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 400,
    width: '100%',
    height: '100%',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    color: '#000000',
  },
  tourSection: {
    padding: 20,
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 400,
  },
  comingSoonText: {
    color: 'white',
    fontFamily: 'VastagoGrotesk',
    fontWeight: '500',
    fontSize: '1.125rem',
    textAlign: 'center',
  },
  gradesSection: {
    flex: 1,
    minWidth: 240,
    gap: 10,
  },
  gradeCardGroup: {
    flexDirection: 'row',
    justifyContent: 'center',
    flexWrap: Platform.OS === 'web' ? 'nowrap' : 'wrap',
    gap: 20,
    marginBottom: 20,
    width: '100%',
    '@media (max-width: 768px)': {
      flexWrap: 'wrap',
      gap: 15,
      justifyContent: 'center',
    },
    '@media (max-width: 480px)': {
      flexDirection: 'column',
      gap: 10,
      alignItems: 'center',
      width: '100%',
    }
  },
  gradeCard: {
    flex: 1,
    minWidth: Platform.OS === 'web' ? '200px' : '100%',
    maxWidth: Platform.OS === 'web' ? '33%' : '100%',
    // backgroundColor: colors.backgroundSquares,
    borderRadius: borderRadius.lg,
    padding: spacing.lg,
    alignItems: 'center',
    justifyContent: 'center',
    ...Platform.select({
      web: {
        boxShadow: shadows.card,
      }
    }),
    '@media (max-width: 768px)': {
      maxWidth: '48%',
      minWidth: '150px',
      padding: spacing.md,
    },
    '@media (max-width: 480px)': {
      maxWidth: '100%',
      minWidth: '100%',
      marginBottom: 10,
      padding: spacing.md,
      width: '100%',
    }
  },
  affiliateInfo: {
    marginTop: 5,
    color: '#0f0f0f',
    fontFamily: 'VastagoGrotesk',
    fontSize: 16,
    opacity: 0.8,
  },
  featureBadgesBox: {
    marginTop: 12,
    alignSelf: 'stretch',
  },
  featureBadgesRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: getResponsiveValue({ mobile: 6, tablet: 8, laptop: 10, desktop: 10 }),
  },
  featureBadgeItem: {
    backgroundColor: 'transparent',
    borderWidth: 2,
    borderColor: '#ffffff',
    borderRadius: 0,
    paddingVertical: 6,
    paddingHorizontal: 12,
  },
  featureBadgeItemText: {
    color: '#ffffff',
    fontFamily: 'VastagoGrotesk',
    fontSize: getResponsiveValue({ mobile: 12, tablet: 14, laptop: 16, desktop: 16 }),
    fontWeight: '500',
  },
  categoryContainer: {
    width: getResponsiveValue({
      mobile: '95%',
      tablet: '100%',
      laptop: '100%',
      desktop: '100%',
    }),
    gap: 15,
    marginTop: 20,
    alignSelf: 'center',
  },
  categoryRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: 15,
    width: '100%',
    paddingHorizontal: getResponsiveValue({
      mobile: 5,
      tablet: 0,
      laptop: 0,
      desktop: 0,
    }),
    '@media (max-width: 480px)': {
      flexDirection: 'column',
      alignItems: 'center',
    }
  },
  mediaSection: {
    flex: 1,
    width: '100%',
    alignItems: 'center',
    gap: 20,
  },
  photoGallery: {
    width: '100%',
    height: '100%',
    position: 'relative',
    borderRadius: 10,
    overflow: 'hidden',
  },
  venueImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: 10,
  },
  photoControls: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 10,
    marginTop: 10,
    flexWrap: 'wrap',
  },
  photoButton: {
    backgroundColor: 'rgba(255,255,255,0.1)',
    paddingVertical: 8,
    paddingHorizontal: getResponsiveValue({
      mobile: 12,
      tablet: 15,
      laptop: 15,
      desktop: 15,
    }),
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
  },
  photoButtonText: {
    color: 'white',
    fontFamily: 'VastagoGrotesk',
    fontSize: getResponsiveValue({
      mobile: '0.75rem',
      tablet: '0.875rem',
      laptop: '0.875rem',
      desktop: '0.875rem',
    }),
  },
  photoCounter: {
    color: 'white',
    fontSize: '1rem',
    fontFamily: 'VastagoGrotesk',
  },
  actionButtonGroup: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 10,
    width: getResponsiveValue({
      mobile: '95%',
      tablet: '100%',
      laptop: '100%',
      desktop: '100%',
    }),
    alignSelf: 'center',
    marginHorizontal: getResponsiveValue({
      mobile: 'auto',
      tablet: 0,
      laptop: 0,
      desktop: 0,
    }),
  },
  // Grade Card Styles
  gradeCardTitle: {
    fontFamily: 'VastagoGrotesk',
    fontWeight: '500',
    fontSize: '1.125rem',
    color: 'white',
    marginBottom: 10,
    textAlign: 'center',
    letterSpacing: 2,
    '@media (max-width: 480px)': {
      fontSize: '1rem',
    }
  },
  gradeCardGrade: {
    fontFamily: 'VastagoGrotesk',
    fontWeight: '700',
    fontSize: '3rem',
    color: 'white',
    letterSpacing: 3,
    '@media (max-width: 480px)': {
      fontSize: '2.25rem',
    }
  },
  // Category Button Styles
  categoryButton: {
    flex: 1,
    minWidth: 160,
    backgroundColor: 'rgba(255,255,255,0.1)',
    borderRadius: 10,
    padding: 20,
    alignItems: 'center',
    justifyContent: 'center',
    ...(Platform.OS === 'web' && {
      cursor: 'pointer',
    }),
  },
  categoryButtonText: {
    fontFamily: 'VastagoGrotesk',
    fontSize: '0.75rem',
    color: '#000000',
    textAlign: 'center',
    letterSpacing: 1.5,
  },
  primaryButton: {
    backgroundColor: '#2ecc71',
  },
  mediaContainer: {
    flex: 1,
    width: '100%',
    height: '100%',
    minHeight: getResponsiveValue({
      mobile: 400,
      tablet: 450,
      laptop: 500,
      desktop: 500,
    }),
    display: 'flex',
    borderRadius: 10,
    overflow: 'hidden',

    marginTop: getResponsiveValue({
      mobile: 10,
      tablet: 10,
      laptop: 0,
      desktop: 0,
    }),
  },
  mapContainer: {
    width: '100%',
    height: '100%',
    minHeight: getResponsiveValue({
      mobile: 250,
      tablet: 300,
      laptop: 500,
      desktop: 500,
    }),
    borderRadius: 10,
    overflow: 'hidden',
  },
  mapWrapper: {
    width: '100%',
    height: '100%',
    minHeight: 320,
    borderRadius: 10,
    overflow: 'hidden',
    position: 'relative',
  },
  mapFullscreenButton: {
    position: 'absolute',
    top: 12,
    right: 12,
    zIndex: 10,
    padding: 8,
    borderRadius: 8,
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    ...(Platform.OS === 'web' && { cursor: 'pointer' }),
  },
  mapFullscreenOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.85)',
    justifyContent: 'center',
    alignItems: 'stretch',
  },
  mapFullscreenHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 20,
    paddingVertical: 12,
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
  },
  mapFullscreenHeaderLeft: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
  },
  mapFullscreenActionBtn: {
    paddingVertical: 8,
    paddingHorizontal: 14,
    borderRadius: 8,
    backgroundColor: 'rgba(0, 0, 0, 0.08)',
  },
  mapFullscreenActionBtnText: {
    fontFamily: 'EduSAHand',
    fontSize: 16,
    color: '#1d1d1d',
    fontWeight: '600',
  },
  mapFullscreenExitBtn: {
    padding: 8,
    borderRadius: 8,
    backgroundColor: 'rgba(0, 0, 0, 0.08)',
  },
  mapAddLocationButton: {
    position: 'absolute',
    bottom: 12,
    left: 12,
    right: 12,
    zIndex: 10,
    paddingVertical: 10,
    paddingHorizontal: 14,
    borderRadius: 8,
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    alignItems: 'center',
    justifyContent: 'center',
    ...(Platform.OS === 'web' && { cursor: 'pointer' }),
  },
  mapAddLocationButtonText: {
    fontFamily: 'VastagoGrotesk', // same as the search bar input (homeStyles.searchInput)
    fontSize: 14,
    color: '#1d1d1d',
  },
  mapFullscreenContent: {
    flex: 1,
    minHeight: 400,
  },
  mapStyleToggleBtn: {
    paddingVertical: 8,
    paddingHorizontal: 16,
    borderRadius: 8,
    backgroundColor: 'rgba(0, 0, 0, 0.08)',
  },
  mapStyleToggleText: {
    fontFamily: 'EduSAHand',
    fontSize: 16,
    color: '#1d1d1d',
  },
  viewButtonsContainer: {
    flexDirection: getResponsiveValue({
      mobile: 'column',
      tablet: 'row',
      laptop: 'row',
      desktop: 'row',
    }),
    width: '100%',
    marginTop: 10,
    gap: getResponsiveValue({
      mobile: 5,
      tablet: 10,
      laptop: 10,
      desktop: 10,
    }),
    justifyContent: 'space-between',
    borderTopWidth: 1,
    borderTopColor: 'rgba(0, 0, 0, 0.1)',
  },
  viewButton: {
    flex: 1,
    backgroundColor: '#FFE99C',
    padding: 15,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 8,
    width: getResponsiveValue({
      mobile: '100%',
      tablet: '31%',
      laptop: '31%',
      desktop: '31%',
    }),
    textAlign: 'center',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    ...(Platform.OS === 'web' && {
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      ':hover': {
        backgroundColor: '#3D7FE6',
        transform: 'translateY(-2px)',
      },
      ':active': {
        backgroundColor: '#3D7FE6',
        transform: 'translateY(0px)',
      }
    }),
  },
  viewButtonText: {
    color: '#3D7FE6',
    fontFamily: 'VastagoGrotesk',
    fontSize: '0.875rem',
    textTransform: 'uppercase',
    fontWeight: '500',
    textAlign: 'center',
    width: '100%',
    ...(Platform.OS === 'web' && {
      transition: 'color 0.2s ease',
    }),
  },
  viewButtonHovered: {
    backgroundColor: '#3D7FE6',
    transform: 'translateY(-2px)',
  },
  viewButtonTextHovered: {
    color: '#DBC0FC',
  },
  viewButtonActive: undefined,
  viewButtonActiveText: undefined,
  noContentText: {
    color: '#000000',
    fontFamily: 'VastagoGrotesk',
    fontSize: '1rem',
    textAlign: 'center',
    marginTop: 20,
  },
  manualBackground: {
    width: '100%',
    height: '100%',
  },
  manualBackgroundImage: {
    opacity: 0.3,
  },
  manualContent: {
    flex: 1,
    backgroundColor: 'transparent',
    padding: 20,
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
  },
  manualButton: {
    backgroundColor: '#ffffff',
    padding: getResponsiveValue({
      mobile: 10,
      tablet: 15,
      laptop: 15,
      desktop: 15,
    }),
    borderRadius: 4,
    minWidth: getResponsiveValue({
      mobile: 150,
      tablet: 200,
      laptop: 200,
      desktop: 200,
    }),
    alignItems: 'center',
    marginVertical: 10,
    ...(Platform.OS === 'web' && {
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      ':hover': {
        transform: 'scale(1.03)',
      },
    }),
  },
  manualLinkButtonShadow: {
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.24,
    shadowRadius: 3,
    elevation: 3,
    ...(Platform.OS === 'web' ? { boxShadow: '0px 2px 5px rgba(0,0,0,0.24)' } : {}),
  },
  manualLinkTextShadow: {
    textShadowColor: 'rgba(0,0,0,0.45)',
    textShadowOffset: { width: 0, height: 1 },
    textShadowRadius: 2,
  },
  horizontalManualButton: {
    backgroundColor: '#ffffff',
    padding: getResponsiveValue({
      mobile: 10,
      tablet: 15,
      laptop: 15,
      desktop: 15,
    }),
    borderRadius: 4,
    minWidth: getResponsiveValue({
      mobile: 80,
      tablet: 80,
      laptop: 100,
      desktop: 100,
    }),
    alignItems: 'center',
    marginVertical: 10,
    ...(Platform.OS === 'web' && {
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      ':hover': {
        transform: 'scale(1.03)',
      },
    }),
  },
  specSheetsContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 10,
    flexWrap: 'wrap',
    marginBottom: 40,
  },
  manualButtonText: {
    color: '#000000',
    fontFamily: 'VastagoGrotesk',
    fontSize: getResponsiveValue({
      mobile: '0.875rem',
      tablet: '1rem',
      laptop: '1rem',
      desktop: '1rem',
    }),
  },
  manualHeaderText: {
    width: '100%',
    textAlign: 'center',
    marginBottom: getResponsiveValue({
      mobile: 5,
      tablet: 5,
      laptop: 10,
      desktop: 10,
    }),
    color: '#292C35',
    fontFamily: 'VastagoGrotesk',
    fontWeight: 'bold',
    fontSize: getResponsiveValue({
      mobile: '0.875rem',
      tablet: '1rem',
      laptop: '1rem',
      desktop: '1rem',
    }),
  },
  titleCard: {
    flex: getResponsiveValue({
      mobile: 2,
      tablet: 2,
      laptop: 1.5,
      desktop: 1.5,
    }),
    // backgroundColor: '#3D7FE6',
    borderRadius: 10,
    paddingTop: 20,
    paddingLeft: 20,
    paddingRight: 20,
    paddingBottom: 10,
    order: getResponsiveValue({
      mobile: 1,
      tablet: 1,
      laptop: 2,
      desktop: 2,
    }),
    position: 'relative',
    minHeight: getResponsiveValue({
      mobile: 'auto',
      tablet: 'auto',
      laptop: '100%',
      desktop: '100%',
    }),
  },
  titleCardFolderIconWrapper: {
    position: 'absolute',
    top: getResponsiveValue({ mobile: 10, tablet: 14, laptop: 16, desktop: 16 }),
    right: getResponsiveValue({ mobile: 10, tablet: 14, laptop: 16, desktop: 16 }),
    zIndex: 10,
  },
  titleCardFolderIcon: {
    padding: 6,
    ...(Platform.OS === 'web' && { cursor: 'pointer' }),
  },
  titleCardFolderIconImage: {
    width: getResponsiveValue({ mobile: 28, tablet: 36, laptop: 40, desktop: 42 }),
    height: getResponsiveValue({ mobile: 28, tablet: 36, laptop: 40, desktop: 42 }),
  },
  folderDropdown: {
    position: 'absolute',
    top: '100%',
    right: 0,
    marginTop: 4,
    minWidth: 180,
    backgroundColor: '#fff',
    borderRadius: 8,
    paddingVertical: 6,
    paddingHorizontal: 0,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.2,
    shadowRadius: 8,
    elevation: 8,
    zIndex: 20,
  },
  folderDropdownOption: {
    paddingVertical: 10,
    paddingHorizontal: 14,
    ...(Platform.OS === 'web' && { cursor: 'pointer' }),
  },
  folderDropdownOptionText: {
    fontSize: 14,
    color: '#1d1d1d',
    fontFamily: 'VastagoGrotesk',
  },
  actionButtonsContainer: {
    flexDirection: getResponsiveValue({
      mobile: 'column',
      tablet: 'row',
      laptop: 'row',
      desktop: 'row',
    }),
    justifyContent: 'space-around',
    flexWrap: 'wrap',
    gap: 10,
    marginTop: 15,
    marginBottom: 0,

    width: getResponsiveValue({
      mobile: '95%',
      tablet: '100%',
      laptop: '100%',
      desktop: '100%',
    }),
    alignSelf: 'center',

  },
  // Tech Specs Styles
  techSpecsContainer: {
    width: '100%',
    padding: 15,
    // backgroundColor: colors.backgroundSquares,
    borderRadius: 10,
    marginTop: 15,
    height: getResponsiveValue({
      mobile: 'auto',
      tablet: 'auto',
      laptop: 'auto',
      desktop: 'auto'
    }),
    maxHeight: getResponsiveValue({
      mobile: 'none',
      tablet: 'none',
      laptop: 'auto',
      desktop: 'auto'
    }),
    overflow: getResponsiveValue({
      mobile: 'visible',
      tablet: 'visible',
      laptop: 'auto',
      desktop: 'auto'
    }),
  },
  techSpecRow: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingVertical: 10,
    borderBottomWidth: 1,
    borderBottomColor: 'rgba(255,255,255,0.1)',
    gap: 15,
  },
  techSpecLabel: {
    fontFamily: 'VastagoGrotesk',
    fontSize: '1rem',
    color: '#000000',
    fontWeight: '500',
    // textShadow: Platform.OS === 'web' ? '0px 2px 2px rgba(0,0,0,0.25)' : undefined,
    minWidth: 120,
    fontWeight: 'bold',
  },
  techSpecValue: {
    fontFamily: 'VastagoGrotesk',
    fontSize: '1rem',
    color: '#000000',
    // textShadow: Platform.OS === 'web' ? '0px 2px 2px rgba(0,0,0,0.25)' : undefined,
    flex: 1,
  },
  websiteButton: {
    backgroundColor: colors.visitWebsiteLink,
    paddingHorizontal: 20,
    paddingVertical: 10,
    borderRadius: 5,
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    gap: 10,
    alignSelf: 'flex-start',
    ...(Platform.OS === 'web' && {
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      ':hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      },
    }),
  },
  websiteButtonText: {
    color: 'white',
    fontFamily: 'VastagoGrotesk',
    fontSize: '0.875rem',
    fontWeight: '500',
  },
  reportsSection: {
    marginTop: spacing.xl,
    width: '100%',
  },
  reportsContainer: {
    width: '100%',
    maxHeight: 500,
  },
  reportCard: {
    // backgroundColor: colors.backgroundSquares,
    borderRadius: 10,
    padding: 15,
    marginBottom: 15,
  },
  reportHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: spacing.md,
  },
  reportUserInfo: {
    flex: 1,
  },
  reportUserName: {
    color: colors.white,
    fontSize: typography.size.lg,
    fontFamily: typography.fontFamily.bold,
    marginBottom: spacing.xs,
  },
  reportDate: {
    color: colors.textSecondary,
    fontSize: typography.size.sm,
    fontFamily: typography.fontFamily.regular,
  },
  reportGrade: {
    backgroundColor: colors.primary,
    borderRadius: borderRadius.sm,
    padding: spacing.sm,
    minWidth: 40,
    alignItems: 'center',
  },
  reportContent: {
    marginTop: spacing.md,
  },
  reportExperience: {
    color: colors.white,
    fontSize: typography.size.md,
    fontFamily: typography.fontFamily.regular,
    marginBottom: spacing.lg,
  },
  ratingsGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: spacing.md,
    marginBottom: spacing.lg,
  },
  ratingItem: {
    backgroundColor: colors.backgroundTertiary,
    borderRadius: borderRadius.sm,
    padding: spacing.sm,
    minWidth: 100,
    alignItems: 'center',
  },
  ratingLabel: {
    color: '#000000',
    fontSize: typography.size.sm,
    fontFamily: typography.fontFamily.medium,
    marginBottom: spacing.xs,
  },
  ratingValue: {
    color: colors.white,
    fontSize: typography.size.lg,
    fontFamily: 'DazHandwriting',
  },
  mediaSection: {
    marginTop: spacing.lg,
  },
  mediaLabel: {
    color: colors.white,
    fontSize: typography.size.md,
    fontFamily: typography.fontFamily.medium,
    marginBottom: spacing.sm,
  },
  mediaScroll: {
    // backgroundColor: colors.backgroundSquares,
    padding: 10,
    borderRadius: 8,
    marginVertical: 10,
  },
  mediaPreview: {
    width: 120,
    height: 120,
    borderRadius: borderRadius.sm,
    marginRight: spacing.sm,
  },
  notesSection: {
    marginTop: spacing.lg,
  },
  notesLabel: {
    color: '#000000',
    fontSize: typography.size.md,
    fontFamily: typography.fontFamily.medium,
    marginBottom: spacing.sm,
  },
  notesText: {
    color: colors.textSecondary,
    fontSize: typography.size.md,
    fontFamily: typography.fontFamily.regular,
  },
  emptyStateContainer: {
    padding: spacing.xl,
    alignItems: 'center',
    justifyContent: 'center',
  },
  emptyStateText: {
    color: getResponsiveValue({
      mobile: '#FFFFFF',
      tablet: '#000000',
      laptop: '#000000',
      desktop: '#000000',
    }),
    fontSize: typography.size.lg,
    fontFamily: typography.fontFamily.medium,
    textAlign: 'center',
  },
  saveButton: {
    position: 'absolute',
    top: -25,
    right: -25,
    zIndex: 999,
    padding: 12,
    display: getResponsiveValue({
      mobile: 'flex',
      tablet: 'flex',
      laptop: 'none',
      desktop: 'none',
    }),
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    transform: 'rotate(10deg)',
    transition: 'transform 0.3s ease-in-out, filter 0.3s ease-in-out',
    cursor: 'pointer',
    '@media (hover: hover)': {
      '&:hover': {
        transform: 'rotate(10deg) scale(1.2)',
        filter: 'brightness(1.2)',
      }
    }
  },

  saveButtonText: {
    color: 'white',
    fontFamily: 'VastagoGrotesk',
    fontSize: '1rem',
    textAlign: 'center',
    textTransform: 'uppercase',
    letterSpacing: 1,
    textShadow: '0 1px 2px rgba(0,0,0,0.3)',
    transform: Platform.OS === 'web' ? 'translateY(2px)' : undefined,
  },
  venueLayout: {
    flex: getResponsiveValue({
      mobile: 2,
      tablet: 2,
      laptop: 1.5,
      desktop: 1.5,
    }),
    marginBottom: 20,
    display: 'flex',
    minHeight: 600,
    width: '100%',
    marginTop: getResponsiveValue({
      mobile: 10,
      tablet: 15,
      laptop: 20,
      desktop: 20,
    }),
    flexDirection: getResponsiveValue({
      mobile: 'column',
      tablet: 'column',
      laptop: 'column',
      desktop: 'column'
    }),
    gap: getResponsiveValue({
      mobile: 10,
      tablet: 20,
      laptop: 20,
      desktop: 20
    }),
    alignItems: 'center'
  },
  leftColumnFiller: {
    flex: getResponsiveValue({
      mobile: 1,
      tablet: 1,
      laptop: 0.7,
      desktop: 0.7,
    }),
    padding: 10,
    alignItems: 'center',
    justifyContent: 'center',
    width: getResponsiveValue({
      mobile: '90vw',
      tablet: 'auto',
      laptop: 'auto',
      desktop: 'auto',
    }),
    alignSelf: getResponsiveValue({
      mobile: 'center',
      tablet: 'auto',
      laptop: 'auto',
      desktop: 'auto',
    }),
    marginBottom: getResponsiveValue({
      mobile: 0,
      tablet: 0,
      laptop: 0,
      desktop: 0,
    }),
    gap: getResponsiveValue({
      mobile: 0,
      tablet: 0,
      laptop: 5,
      desktop: 5,
    }),
    position: 'relative',
  },
  chatContainer: {
    flex: getResponsiveValue({
      mobile: 'none',
      tablet: 0,
      laptop: 0.75,
      desktop: 0.75,
    }),
  },
  chatContainerHeader: {
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginTop: 8,
    marginBottom: 8,
    minHeight: 32,
  },
  chatroomToggleButton: {
    paddingVertical: 8,
    paddingHorizontal: 14,
    backgroundColor: '#424252',
    borderRadius: 8,
  },
  chatroomToggleButtonText: {
    color: '#ffcb99',
    fontSize: 14,
    fontWeight: '600',
    fontFamily: 'VastagoGrotesk',
  },
  leftColumn: {
    flex: 1,
    minWidth: getResponsiveValue({
      mobile: '90vw',
      tablet: '100%',
      laptop: '100%',
      desktop: '100%'
    }),
    alignSelf: getResponsiveValue({
      mobile: 'center',
      tablet: 'auto',
      laptop: 'auto',
      desktop: 'auto'
    }),
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'transparent',
    backdropFilter: 'blur(10px)',
    borderWidth: 3,
    borderColor: '#000000',
    borderRadius: 10,
    padding: 15,
    height: 'auto',
    minHeight: 'fit-content',
    flexGrow: 1,
    flexShrink: 0
  },
  rightColumn: {
    flex: 1,
    minWidth: getResponsiveValue({
      mobile: '90vw',
      tablet: '100%',
      laptop: '35%',
      desktop: '35%'
    }),
    alignSelf: getResponsiveValue({
      mobile: 'center',
      tablet: 'auto',
      laptop: 'auto',
      desktop: 'auto'
    }),
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'transparent',
    backdropFilter: 'blur(10px)',
    borderWidth: 3,
    borderColor: '#FFE99C',
    borderRadius: 10,
    padding: 15,
    marginTop: getResponsiveValue({
      mobile: 0,
      tablet: 0,
      laptop: 0,
      desktop: 0
    }),
    minHeight: getResponsiveValue({
      mobile: 'auto',
      tablet: 'auto',
      laptop: 'auto',
      desktop: 'auto'
    }),
    height: Platform.OS === 'web' ? getResponsiveValue({
      mobile: 'auto',
      tablet: 'auto',
      laptop: 'var(--left-column-height)',
      desktop: 'var(--left-column-height)'
    }) : 'auto',
    maxHeight: getResponsiveValue({
      mobile: 'none',
      tablet: 'none',
      laptop: undefined,
      desktop: undefined
    }),
    overflow: getResponsiveValue({
      mobile: 'visible',
      tablet: 'visible',
      laptop: 'auto',
      desktop: 'auto'
    }),
  },
  mapCard: {
    flex: getResponsiveValue({
      mobile: 1,
      tablet: 0,
      laptop: 0.75,
      desktop: 0.75,
    }),
    // backgroundColor: colors.backgroundSquares,
    borderRadius: 10,
    padding: 0,
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    order: getResponsiveValue({
      mobile: 3,
      tablet: 3,
      laptop: 3,
      desktop: 3,
    }),
    display: getResponsiveValue({
      mobile: 'flex',
      tablet: 'none',
      laptop: 'flex',
      desktop: 'flex',
    }),
    minHeight: getResponsiveValue({
      mobile: 'auto',
      tablet: 'auto',
      laptop: '100%',
      desktop: '100%',
    }),
    maxHeight: getResponsiveValue({
      mobile: 'auto',
      tablet: 'auto',
      laptop: '100%',
      desktop: '100%',
    }),
    marginTop: getResponsiveValue({
      mobile: 0,
      tablet: 0,
      laptop: 0,
      desktop: 0,
    }),
    marginBottom: getResponsiveValue({
      mobile: 0,
      tablet: 0,
      laptop: 0,
      desktop: 0,
    }),
    overflow: 'hidden',
  },
  searchContainer: {
    position: 'relative',
    width: '100%',
    maxWidth: getResponsiveValue({
      mobile: '100%',
      tablet: 600,
      laptop: 800,
      desktop: 900
    }),
    marginBottom: 20,
  },
  locationIconContainer: {
    position: 'absolute',
    right: getResponsiveValue({
      mobile: 15,
      tablet: 20,
      laptop: 20,
      desktop: 25,
    }),
    top: '50%',
    transform: Platform.OS === 'web' ? 'translateY(-50%)' : undefined,
    height: getResponsiveValue({
      mobile: 30,
      tablet: 40,
      laptop: 40,
      desktop: 40,
    }),
    width: getResponsiveValue({
      mobile: 30,
      tablet: 40,
      laptop: 40,
      desktop: 40,
    }),
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 10,
    ...(Platform.OS === 'web' && {
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      ':hover': {
        transform: 'translateY(-50%) scale(1.1)',
      },
    }),
  },
  svgIcon: {
    width: 24,
    height: 24,
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
  },
  locationDot: {
    position: 'absolute',
    width: 6,
    height: 6,
    borderRadius: 3,
    backgroundColor: '#000000',
    zIndex: 2,
    top: '50%',
    left: '50%',
    transform: Platform.OS === 'web' ? 'translate(-50%, -50%)' : undefined,
  },
  locationRing: {
    position: 'absolute',
    width: 18,
    height: 18,
    borderRadius: 10,
    borderWidth: 1.5,
    borderColor: '#000000',
    backgroundColor: 'transparent',
    top: '50%',
    left: '50%',
    transform: Platform.OS === 'web' ? 'translate(-50%, -50%)' : undefined,
  },
  votingContainer: {
    backdropFilter: 'none',
    padding: 15,
    marginTop: 20,
    marginBottom: 40,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    backgroundColor: 'transparent',
  },
  smallerVotingContainer: {
    backdropFilter: 'none',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',
  },
  smallerVotingText: {
    color: '#000000',
    marginRight: 10,
    fontSize: 14,
    fontFamily: 'VastagoGrotesk',
  },
  votingText: {
    color: '#000000',
    marginRight: 20,
    fontSize: 18,
    fontFamily: 'VastagoGrotesk',
  },
  voteButton: {
    marginRight: 15,
    opacity: 0.7,
    flexDirection: 'row',
    alignItems: 'center',
  },
  voteCount: {
    color: '#000000',
    marginLeft: 5,
    fontFamily: 'VastagoGrotesk',
  },
  discussionText: {
    color: '#000000',
    fontFamily: 'VastagoGrotesk',
  },
  discussionInput: {
    color: '#000000',
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
    borderRadius: 8,
    padding: 10,
    width: '100%',
    fontFamily: 'VastagoGrotesk',
    borderWidth: 1,
    borderColor: 'rgba(0, 0, 0, 0.1)',
  },
  discussionPlaceholder: {
    color: 'rgba(0, 0, 0, 0.5)',
  },
  // Photo Collage Styles
  photoCollageContainer: {
    width: '100%',
    height: '100%',
    padding: 5,
  },
  photoCollageGrid: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    width: '100%',
    gap: 10,
    paddingBottom: 20,
  },
  photoCollageItem: {
    width: getResponsiveValue({
      mobile: '48%',
      tablet: '48%',
      laptop: '48%',
      desktop: '48%',
    }),
    aspectRatio: 1,
    marginBottom: 10,
    borderRadius: 8,
    overflow: 'hidden',
    position: 'relative',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)',
    cursor: 'pointer',
    transition: 'transform 0.2s ease-in-out',
    ':hover': {
      transform: 'scale(1.02)',
    },
  },
  mobilePhotoCollageItem: {
    fontFamily: 'Computer Says No',
    borderRadius: 8,
    height: 200,
    width: '100%',
    maxWidth: 250,
    flexDirection: 'column',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 5,
    backgroundColor: '#e9e9e8',
    padding: 10,
    overflow: 'hidden',
    border: '2px solid #424252'
  },
  photoCollageImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },

  mobilePhotoCollageImage: {
    width: '100%',
    height: '80%',
    objectFit: 'cover',
  },
  mobilePhotoCollageUsername: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    color: 'black',
    fontSize: 12,
    fontFamily: 'VastagoGrotesk',
    fontWeight: '500',
    textShadow: '0 1px 3px rgba(0,0,0,0.2)',
  },
  photoCollageUsername: {
    position: 'absolute',
    bottom: 10,
    left: 10,
    color: 'black',
    fontSize: 14,
    fontFamily: 'VastagoGrotesk',
    fontWeight: '500',
    textShadow: '0 1px 3px rgba(0,0,0,0.8)',
  },
  mobilePhotoCollageUsernameContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  mobilePhotoCollageTimestamp: {
    color: 'black',
    fontSize: 20,
    fontFamily: 'Computer Says No',
  },
  photoCollageTimestamp: {
    color: 'rgba(255, 255, 255, 0.7)',
    fontSize: 10,
    fontFamily: 'VastagoGrotesk',
  },
  // Add new modal styles
  photoModal: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.95)',
    zIndex: 9999,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContent: {
    width: '100%',
    height: '100%',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalImage: {
    maxWidth: '95vw',
    maxHeight: '95vh',
    objectFit: 'contain',
  },
  modalClose: {
    position: 'absolute',
    top: 20,
    right: 20,
    color: 'white',
    fontSize: 32,
    cursor: 'pointer',
    width: 50,
    height: 50,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    borderRadius: '50%',
    zIndex: 10000,
    transition: 'all 0.2s ease',
    ':hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      transform: 'scale(1.1)',
    },
  },
  modalNav: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    color: 'white',
    fontSize: 48,
    cursor: 'pointer',
    width: 80,
    height: 80,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    borderRadius: '50%',
    transition: 'all 0.2s ease',
    zIndex: 10000,
    ':hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      transform: 'translateY(-50%) scale(1.1)',
    },
  },
  modalNavPrev: {
    left: 20,
  },
  modalNavNext: {
    right: 20,
  },
  modalInfo: {
    position: 'absolute',
    bottom: 20,
    left: 0,
    right: 0,
    color: 'white',
    textAlign: 'center',
    fontFamily: 'VastagoGrotesk',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    padding: 15,
    zIndex: 10000,
  },
  modalUsername: {
    fontSize: 18,
    fontWeight: '500',
    marginBottom: 5,
  },
  modalTimestamp: {
    fontSize: 16,
    opacity: 0.7,
  },
  cardTitle: {
    fontFamily: 'VastagoGrotesk',
    fontWeight: '700',
    fontSize: Platform.OS === 'web' ? 24 : 20,
    color: '#000000',
    textAlign: 'center',
    marginBottom: 10,
  },
  // Tech Specs Styles (Mobile)
  techSpecMobileView: {
    width: '100%',
    minHeight: 'fit-content',
    height: 'auto',
    overflow: 'visible',
    maxHeight: 'none',
    display: 'flex',
    flexDirection: 'column',
    borderWidth: 0,
    padding: 10,
    marginBottom: 20,
    flexGrow: 1,
    flexShrink: 0,
    alignSelf: 'stretch'
  },
  mobileDisplayButtons: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '100%',
    alignItems: 'center',
    marginTop: getResponsiveValue({ mobile: 30, tablet: 20, laptop: 20, desktop: 20 }),
    gap: getResponsiveValue({
      mobile: 5,
      tablet: 8,
      laptop: 10,
      desktop: 10,
    }),
  },
  mobileDisplayButtonsRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    width: '100%',
    alignSelf: 'center',
  },
  mobileOptionsToggleRow: {
    flexDirection: 'row',
    justifyContent: 'center',
    gap: getResponsiveValue({
      mobile: 10,
      tablet: 15,
      laptop: 20,
      desktop: 20,
    }),
    flexWrap: 'wrap',
    width: '100%',
    alignSelf: 'center',
  },
  mobileShareViewRow: {
    flexDirection: getResponsiveValue({ mobile: 'column', tablet: 'column', medium: 'column', laptop: 'row', desktop: 'row' }),
    width: '100%',
    gap: getResponsiveValue({ mobile: 5, tablet: 5, medium: 5, laptop: 16, desktop: 16 }),
    alignItems: 'stretch',
  },
  mobileSlotExpanded: {
    flex: 1,
    minHeight: 90,
    justifyContent: 'flex-start',
  },
  mobileSlotHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 4,
    paddingVertical: 6,
    marginBottom: 4,
  },
  mobileSlotHeaderText: {
    fontFamily: 'EduSAHand',
    fontSize: 14,
    letterSpacing: 1.5,
    color: '#424251',
  },
  mobileSlotOptionsRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    flex: 1,
    justifyContent: 'center',
    gap: getResponsiveValue({
      mobile: 5,
      tablet: 8,
      laptop: 10,
      desktop: 10,
    }),
    maxHeight: 56,
  },
  mobileOptionButtonSmall: {
    width: '31%',
    aspectRatio: 1,
    marginBottom: 0,
  },
  mobileOptionButtonSmallText: {
    letterSpacing: 1.5,
  },
  mobileOptionsToggleButton: {
    backgroundColor: '#FFE99C',
    width: '32%',
    aspectRatio: 1,
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    padding: 5,
    borderRadius: 5,
    marginBottom: getResponsiveValue({
      mobile: 10,
      tablet: 10,
      laptop: 15,
      desktop: 15,
    }),
  },
  mobileOptionsToggleButtonActive: {
    backgroundColor: '#FFE99C',
  },
  mobileOptionsToggleButtonText: {
    color: '#424251',
    fontFamily: 'EduSAHand',
    letterSpacing: 3.4,
    textAlign: 'center',
  },
  mobileOptionsToggleButtonTextActive: {
    color: '#4e7de0',
  },
  mobileOptionsPanel: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    width: '100%',
    alignSelf: 'center',
  },
  mobileOptionBox: {
    backgroundColor: '#FFE99C',
    width: '32%',
    aspectRatio: 1,
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    padding: 5,
    borderRadius: 5,
    marginBottom: getResponsiveValue({
      mobile: 10,
      tablet: 10,
      laptop: 15,
      desktop: 15,
    }),
  },
  mobileOptionBoxText: {
    color: '#424251',
    fontFamily: 'EduSAHand',
    letterSpacing: 3.4,
    textAlign: 'center',
    textTransform: 'uppercase',
    fontSize: getResponsiveValue({ mobile: 12, tablet: 12, laptop: 13, desktop: 13 }),
  },
  mobileButton: {
    backgroundColor: '#FFE99C',
    width: getResponsiveValue({ mobile: '31.5%', tablet: '29', laptop: '31.5%', desktop: '31.5%' }),
    aspectRatio: 1,
    justifyContent: "center",
    alignItems: "center",
    display: 'flex',
    padding: 5,
    borderRadius: 5,
    marginBottom: getResponsiveValue({
      mobile: 10,
      tablet: 10,
      laptop: 15,
      desktop: 15,
    }),
  },
  mobileButtonText: {
    textAlign: "center",
    fontFamily: 'EduSAHand',
    letterSpacing: 3.4,
  },
  activeMobileButtonText: {
    color: '#4e7de0',
  },
  inactiveMobileButtonText: {
    color: '#424251',
  },
  mobileManualsContainer: {
    flex: 1,
    width: '100%',
    minHeight: 300,
    display: 'flex',
    borderRadius: 10,
    border: '3px solid #FFE99C',
    padding: 10,
  },
  discussionsAndUploadsContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: getResponsiveValue({
      mobile: 10,
      tablet: 15,
      laptop: 20,
      desktop: 20,
    }),
  },
  discussionAndUploadsBox: {
    width: '100%',
    display: 'flex',
    minHeight: 200,
    backgroundColor: '#e9e9e8',
    borderRadius: 10,
    padding: 10,
    border: '4px solid #424252'
  },
  discussionsAndUploadsTabs: {
    marginTop: 5,
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 2,
  },
  discussionsAndUploadsTabText: {
    fontSize: 14,
    fontFamily: 'VastagoGrotesk',
    fontWeight: '600',
    color: "#dfffdd"
  },
  discussionsAndUploadsTab: {
    width: '48%',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    borderRadius: 5,
    height: 30,
    justifyContent: 'center',
    padding: 5,
    backgroundColor: '#424252',
    color: '#dfffdd',
  },

  roomEqMacOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.5)',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 24,
  },
  roomEqMacWindowWrap: {
    width: '100%',
    minWidth: 320,
    maxWidth: 520,
    alignItems: 'center',
  },
  roomEqMacWindow: {
    width: '100%',
    maxHeight: '85vh',
    backgroundColor: '#e5e7e5',
    // backgroundColor: '#b8a9d3',
    borderRadius: 30,
    // borderWidth: 4,
    // borderColor: '#000000',
    paddingVertical: 12,
    overflow: 'hidden',
    ...(Platform.OS === 'web' && { boxShadow: '0 12px 24px rgba(0,0,0,0.2)' }),
  },
  roomEqMacTitleBar: {
    flexDirection: 'row',
    alignItems: 'center',
    height: 50,
    paddingHorizontal: 12,
    backgroundColor: '#e5e7e5',
    // backgroundColor: '#b8a9d3',
    borderBottomWidth: 4,
    borderBottomColor: '#000000',
  },
  roomEqMacTraffic: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    marginRight: 12,
  },
  roomEqMacDot: {
    width: 15,
    height: 15,
    borderWidth: 2,
    borderColor: '#000000',
    borderRadius: 8,
  },
  roomEqMacTitleInput: {
    flex: 1,
    fontSize: 24,
    fontWeight: '700',
    color: '#000000',
    paddingVertical: 6,
    paddingHorizontal: 8,
    fontFamily: 'Computer Says No',
    borderRadius: 6,
    textAlign: 'right',
  },
  roomEqMacTitleText: {
    flex: 1,
    fontSize: 24,
    textAlign: 'right',
    fontFamily: 'Computer Says No',
    fontWeight: '700',
    color: '#424252',
    marginLeft: 4,
  },
  roomEqMacContent: {
    minHeight: 220,
    maxHeight: '65vh',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#e5e7e5',
    // backgroundColor: '#b8a9d3',
    padding: 16,
  },
  roomEqMacArrow: {
    padding: 12,
    justifyContent: 'center',
  },
  roomEqMacImageWrap: {
    flex: 1,
    minHeight: 180,
    justifyContent: 'center',
    alignItems: 'center',
  },
  roomEqMacImage: {
    width: '100%',
    height: 200,
    maxHeight: 280,
  },
  roomEqMacViewerRow: {
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 0,
  },
  roomEqMacViewerArrowOuter: {
    padding: 16,
    justifyContent: 'center',
    minWidth: 48,
    color: '#FFFFFF',
    alignItems: 'center',
  },
  roomEqMacViewerFooter: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    paddingHorizontal: 12,
    paddingVertical: 8,
    // backgroundColor: '#b8a9d3',
    backgroundColor: '#e5e7e5',
  },
  roomEqMacViewerUploader: {
    fontSize: 20,
    color: '#424252',
    fontFamily: 'Computer Says No',
    maxWidth: '70%',
    textAlign: 'right',
  },
  roomEqMacVideoPlaceholder: {
    width: '100%',
    height: 200,
    maxHeight: 280,
    backgroundColor: '#eee',
    borderRadius: 8,
    justifyContent: 'center',
    alignItems: 'center',
  },
  roomEqMacVideoPlaceholderText: {
    fontSize: 20,
    color: '#424252',
    marginTop: 8,
  },
  roomEqMacVideoPlaceholderLink: {
    fontSize: 20,
    color: '#166fff',
    marginTop: 4,
  },
  roomEqMacUploadZone: {
    flex: 1,
    minHeight: 180,
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 20,
    paddingHorizontal: 16,
  },
  roomEqMacUploadIconsRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 32,
    marginBottom: 12,
  },
  roomEqMacUploadTypeIcon: {
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
  },
  roomEqMacUploadTypeLabel: {
    fontSize: 14,
    color: '#424252',
    fontFamily: 'VastagoGrotesk',
  },
  roomEqMacUploadHint: {
    fontSize: 13,
    color: '#666',
    marginBottom: 20,
  },
  roomEqMacUploadButtonLabel: {
    ...(Platform.OS === 'web' && { cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }),
  },
  roomEqMacUploadButton: {
    backgroundColor: '#6e25ff',
    paddingVertical: 12,
    paddingHorizontal: 32,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 140,
  },
  roomEqMacUploadButtonText: {
    color: '#ffffff',
    fontSize: 20,
    fontFamily: 'Computer Says No',
  },
  roomEqMacUploadText: {
    fontSize: 14,
    color: '#888',
    marginTop: 8,
  },
  roomEqMacUploadPreviewWrap: {
    flex: 1,
    width: '100%',
    alignSelf: 'stretch',
    minHeight: 180,
    position: 'relative',
    justifyContent: 'center',
    alignItems: 'center',
  },
  roomEqMacUploadPreview: {
    width: '100%',
    height: 200,
    maxHeight: 280,
  },
  roomEqMacRemoveImage: {
    position: 'absolute',
    top: 8,
    right: 8,
  },
  roomEqMacBelowWindow: {
    marginTop: 16,
    width: '100%',
    maxWidth: 520,
    alignItems: 'center',
  },
  roomEqMacToggleRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    marginBottom: 8,
  },
  roomEqMacToggleLabel: {
    fontSize: 14,
    color: '#FFFFFF',
  },
  roomEqMacToggle: {
    width: 48,
    height: 26,
    borderRadius: 13,
    backgroundColor: '#ccc',
    justifyContent: 'center',
    paddingHorizontal: 2,
  },
  roomEqMacToggleOn: { backgroundColor: '#166fff' },
  roomEqMacToggleThumb: {
    width: 22,
    height: 22,
    borderRadius: 11,
    backgroundColor: '#fff',
    alignSelf: 'flex-start',
  },
  roomEqMacToggleThumbOn: { alignSelf: 'flex-end' },
  roomEqMacError: {
    fontSize: 13,
    color: '#c00',
    marginBottom: 8,
  },
  roomEqMacSubmitRow: {
    flexDirection: 'row',
    gap: 12,
    alignItems: 'center',
    justifyContent: 'center',
  },
  roomEqMacCancelBtn: { paddingVertical: 10, paddingHorizontal: 20, backgroundColor: '#ececec', borderRadius: 8 },
  roomEqMacCancelText: { fontSize: 16, color: '#666' },
  roomEqMacSubmitBtn: {
    paddingVertical: 10,
    paddingHorizontal: 24,
    backgroundColor: '#424252',
    borderRadius: 8,
    minWidth: 100,
    alignItems: 'center',
  },
  roomEqMacSubmitText: { fontSize: 16, color: '#fff', fontWeight: '600' },
  roomEqMacCloseBtn: {
    marginTop: 12,
    paddingVertical: 10,
    paddingHorizontal: 24,
    backgroundColor: '#424252',
    borderRadius: 8,
  },
  roomEqMacCloseText: { fontSize: 20, color: '#fff', fontWeight: '600' },

}); 